import { Image } from "./models";

export const imageShape: Image = {
  base64: null,
  id: null,
  originalFilename: null,
  resizedImages: null,
  url: null,
};
